// extracted by mini-css-extract-plugin
export var addButton = "_d2-0";
export var border = "_d2-8";
export var check = "_d2-h";
export var danger = "_d2-6";
export var dropdownContainer = "_d2-1";
export var editModalBody = "_d2-j";
export var footerContainer = "_d2-i";
export var fullWidth = "_d2-a";
export var hide = "_d2-9";
export var icon = "_d2-3";
export var input = "_d2-7";
export var inputFlex = "_d2-b";
export var inputWrapper = "_d2-c";
export var manualFocus = "_d2-5";
export var optionButton = "_d2-4";
export var pillWrapper = "_d2-e";
export var pointer = "_d2-2";
export var showOverflow = "_d2-f";
export var tagsFlex = "_d2-d";
export var xButton = "_d2-g";